import { Directive, HostBinding } from "@angular/core";

@Directive({
    selector: '[doubleSearchResponsiveUi]'
})

export class DoubleSearchResponsiveUi {
    @HostBinding('class')
    elementClass = 'ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-16';
}

@Directive({
    selector: '[subDoubleSearchResponsiveUi]'
})

export class SubDoubleSearchResponsiveUi {
    @HostBinding('class')
    elementClass = 'ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-12 ant-col-xl-12';
}